import { FC } from "react";
import { IPageAction } from "../../../base/models";
import { MUIIcon } from "../../../widgets";
import { Property } from "../../../base/types";
import clsx from "clsx";
import { useGetProperties } from "../../../base/hooks";

interface IActionLinkProps {
    action: IPageAction
    className?: string
}

export const ActionLink: FC<IActionLinkProps> = ({
    action, className
}) => {
    const { properties } = useGetProperties({ bindings: action.bindings });
    const pageUrl: string | undefined = properties[Property.Url];
    const target: string | undefined = properties[Property.Target];

    if (!pageUrl)
        return <button
            type="button"
            className={className}>
            {action.icon && <MUIIcon iconName={action.icon} className="me-1" />}
            {action.name}
        </button>

    return (
        <a
            className={clsx(className, "btn btn-secondary btn-sm")}
            href={pageUrl}
            target={target || undefined}>
            {action.icon && <MUIIcon iconName={action.icon} className="me-1" />}
            <span>{action.name}</span>
        </a>
    )
}
